/* LE MODULE D'OÙ L'ON VIENT (2026-09-29). Une section COMMUNE (le groupe
   Planification) vit dans deux bandes, Finance et Ventes & Ops. Le menu et
   les flèches ‹ › restent dans la bande par laquelle on est arrivé, au lieu
   de sauter dans la première qui porte la page. Une page qui n'appartient qu'à
   une bande la retient ; la mémoire survit au rafraîchissement. */
const KEY = 'palestre_last_band';
let last = null;
try { last = window.localStorage.getItem(KEY); } catch (e) { /* stockage indisponible */ }

const keysOf = (band) => (band.groups ? band.groups.flatMap((g) => g.items || []) : (band.items || []))
  .filter((i) => i.key).map((i) => i.key);

/** La bande qui porte `page`, celle d'où l'on vient quand il y en a deux. */
export function bandForPage(nav, page) {
  const owners = (nav || []).filter((n) => n.type === 'band' && keysOf(n).includes(page));
  if (owners.length === 1 && owners[0].id !== last) {
    last = owners[0].id;
    try { window.localStorage.setItem(KEY, last); } catch (e) { /* quota */ }
  }
  if (owners.length > 1) return owners.find((b) => b.id === last) || owners[0];
  return owners[0] || null;
}
